import Seo from "../components/Seo";

const terms = [
  {
    title: "1. Licensed drivers only",
    body: "Jobs are offered to licensed London Black Cab drivers only. You must hold a valid TfL taxi driver licence (Green Badge) and a properly licensed, insured vehicle.",
  },
  {
    title: "2. The passenger pays you directly",
    body: "The passenger pays you, the completing driver, the full £100 fare directly inside your cab — by cash or your own card terminal — at the end of the journey.",
  },
  {
    title: "3. £20 referral fee on completed referred jobs",
    body: "For each referred job you accept and successfully complete, you separately owe Essex Black Cab a £20 referral fee, payable after completion. You keep £80 after the fee.",
  },
  {
    title: "4. How and when the fee is paid",
    body: "The £20 fee is paid separately by bank transfer within 24 hours of the successfully completed journey. Bank details are shared privately — they are never published on this page.",
  },
  {
    title: "5. No completed journey, no referral fee",
    body: "If a journey is not completed, no referral fee is due — unless a different arrangement is agreed in writing for a specific case.",
  },
  {
    title: "6. Journeys driven by the owner",
    body: "When the owner of Essex Black Cab drives a booking personally, no referral fee applies.",
  },
  {
    title: "7. Agreement before passenger details",
    body: "Before receiving a passenger's full details, you must confirm that you accept the £20 referral fee payable after completion. Essex Black Cab obtains each driver's explicit written agreement before allocating jobs.",
  },
  {
    title: "8. Passenger confidentiality",
    body: "Passenger information must be handled confidentially and used only to complete the assigned journey. Never share it in driver groups or with anyone else.",
  },
  {
    title: "9. Your freedom to choose",
    body: "You are free to accept or decline any job. There is no subscription, no membership fee and no guaranteed volume of work.",
  },
];

export default function DriverTerms() {
  return (
    <main data-testid="driver-terms-page" className="mx-auto max-w-3xl px-4 py-12 sm:px-6 sm:py-20">
      <Seo
        title="Driver Referral Terms"
        description="Driver referral terms for Essex Black Cab: £20 referral fee on completed referred £100 journeys, paid by bank transfer within 24 hours. No completed journey, no referral fee."
        noindex
      />
      <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#D4AF37]">
        For drivers
      </p>
      <h1 className="mt-3 text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
        Driver Referral Terms
      </h1>
      <p className="mt-4 leading-relaxed text-[#A1A1AA]">
        These terms apply to journeys referred by Essex Black Cab to independent, licensed
        London Black Cab drivers. They contain no passenger information and no bank details.
      </p>

      <div className="mt-10 space-y-8">
        {terms.map((t) => (
          <section key={t.title}>
            <h2 className="text-xl font-semibold text-white">{t.title}</h2>
            <p className="mt-2 text-sm leading-relaxed text-[#A1A1AA] sm:text-base">{t.body}</p>
          </section>
        ))}
      </div>

      <p
        data-testid="driver-terms-review-banner"
        className="mt-12 border border-[rgba(212,175,55,0.4)] bg-[rgba(212,175,55,0.08)] p-4 text-sm leading-relaxed text-[#D4D4D8]"
      >
        These terms describe a simple referral arrangement and are pending legal review before
        live operation. Items that may need professional confirmation include the 24-hour
        payment deadline, the written-agreement process, VAT treatment of referral fees, and
        driver employment-status wording.
      </p>
    </main>
  );
}
